import {UnauthorizedError} from '../api/errors'

const NO_REDIRECT_PATHS = new Set(['/login', '/verify'])

/** Redirect unauthenticated users to login; no-op on public auth pages and for non-401 errors. */
export function redirectToLoginForUnauthorized(error: unknown): void {
    if (!(error instanceof UnauthorizedError)) {
        return
    }

    if (NO_REDIRECT_PATHS.has(window.location.pathname)) {
        return
    }

    window.location.href = '/login'
}
